module.exports = __webpack_public_path__ + "img/1241054006.7b97b626.jpg";